export interface CountStructure {
  pendingApproval: number,
  returned: number,
  draft: number,
  active: number,
  inActive: number
}

export enum TypeOfCard {
  JOURNEY = 'Journey',
  EVENT = 'Event',
  SERVICE = 'Service'
}

export interface TotalCountForAllEventServiceJourney {
  journeys: CountStructure,
  services: CountStructure,
  events: CountStructure
}
